import { memo } from 'react';
import { TermsCompleteTemplate } from 'components/templates/TermsCompleteTemplate';

type Props = {};

export const TermsCompletePage = memo((_props: Props) => {
	return <TermsCompleteTemplate />;
});
